

export const checkScreeningCLSelector = (state) => state.screeningColonRetto.checkScreeningCL;

export const declineReasonsCLSelector = (state) => state.screeningColonRetto.declineReasonsCL;

export const collectionCenterCLSelector = (state) => state.screeningColonRetto.collectionCenterCL;
export const geoLocationsCollectionCenterCLSelector = (state) => state.screeningColonRetto.geoLocationsCollectionCenterCL;






